import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import TaskMainCreateRequest from '../../../projects/task/i-service/models/task/request/TaskMainCreateRequest';
import TaskMainEditRequest from '../../../projects/task/i-service/models/task/request/edit/TaskMainEditRequest';
import PageRequest from '../../../pagination-helper/lib/PageRequest';
import EstimatePerformerGetRequest from '../../../projects/task/i-service/models/task/request/EstimatePerformerGetRequest';
import TaskSptintsRequest from '../../../projects/task/i-service/models/task-sprints/TaskSptintsRequest';
import TaskGetRequest from '../../../projects/task/i-service/models/task/request/TaskGetRequest';
import AttachFileTaskRequest from '../../../projects/task/i-service/models/task/request/file/AttachFileTaskRequest';
import GetFilesTaskRequest from '../../../projects/task/i-service/models/task/request/file/GetFilesTaskRequest';
import RemoveFilesTaskRequest from '../../../projects/task/i-service/models/task/request/file/RemoveFilesTaskRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import GetHistoryStatusResponse from '../../../projects/task/i-service/models/task/response/GetHistoryStatusResponse';
import TaskShortInfo from '../../../projects/task/i-service/models/TaskShortInfo';
import EstimatePerformerResponse from '../../../projects/task/i-service/models/task/request/EstimatePerformerResponse';
import TaskSprintsResponse from '../../../projects/task/i-service/models/task-sprints/TaskSprintsResponse';
import TaskMainResponse from '../../../projects/task/i-service/models/task/response/TaskMainResponse';
import FilePageResponse from '../../../files/interfaces/models/response/FilePageResponse';

export default class TaskService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	TaskMainCreateEvent = new Events<WsResponseModelT<Boolean>>();
	TaskMainEditEvent = new Events<WsResponseModelT<Boolean>>();
	GetHistoryStatusEvent = new Events<WsResponseModelT<GetHistoryStatusResponse>>();
	GetTasksShortEvent = new Events<WsResponseModelT<Array<TaskShortInfo>>>();
	GetEstimatePerformersEvent = new Events<WsResponseModelT<Array<EstimatePerformerResponse>>>();
	GetTaskOfSprintIdEvent = new Events<WsResponseModelT<TaskSprintsResponse>>();
	TaskGetEvent = new Events<WsResponseModelT<TaskMainResponse>>();
	AddFileEvent = new Events<WsResponseModelT<String>>();
	GetFilesEvent = new Events<WsResponseModelT<FilePageResponse>>();
	RemoveFilesEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskService', 'TaskMainCreate', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.TaskMainCreateEvent.trigger(res);
		});
		webApiService.on('TaskService', 'TaskMainEdit', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.TaskMainEditEvent.trigger(res);
		});
		webApiService.on('TaskService', 'GetHistoryStatus', 'Main', (res: WsResponseModelT<GetHistoryStatusResponse>) => {
			self.GetHistoryStatusEvent.trigger(res);
		});
		webApiService.on('TaskService', 'GetTasksShort', 'Main', (res: WsResponseModelT<Array<TaskShortInfo>>) => {
			self.GetTasksShortEvent.trigger(res);
		});
		webApiService.on('TaskService', 'GetEstimatePerformers', 'Main', (res: WsResponseModelT<Array<EstimatePerformerResponse>>) => {
			self.GetEstimatePerformersEvent.trigger(res);
		});
		webApiService.on('TaskService', 'GetTaskOfSprintId', 'Main', (res: WsResponseModelT<TaskSprintsResponse>) => {
			self.GetTaskOfSprintIdEvent.trigger(res);
		});
		webApiService.on('TaskService', 'TaskGet', 'Main', (res: WsResponseModelT<TaskMainResponse>) => {
			self.TaskGetEvent.trigger(res);
		});
		webApiService.on('TaskService', 'AddFile', 'Main', (res: WsResponseModelT<String>) => {
			self.AddFileEvent.trigger(res);
		});
		webApiService.on('TaskService', 'GetFiles', 'Main', (res: WsResponseModelT<FilePageResponse>) => {
			self.GetFilesEvent.trigger(res);
		});
		webApiService.on('TaskService', 'RemoveFiles', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFilesEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Для большой формы
	 */
	async TaskMainCreate(query: TaskMainCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'TaskMainCreate',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Редактирования больших полей задачи
	 */
	async TaskMainEdit(request: TaskMainEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'TaskMainEdit',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * История  статусов
	 */
	async GetHistoryStatus(page: PageRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'GetHistoryStatus',
			Value: typeof(page) === 'object' ? JSON.stringify(page) : page,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список задач в кратком описании
	 */
	async GetTasksShort(tasks: Array<number>) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'GetTasksShort',
			Value: typeof(tasks) === 'object' ? JSON.stringify(tasks) : tasks,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поиск
	 */
	async GetEstimatePerformers(request: EstimatePerformerGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'GetEstimatePerformers',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить задачу по ид спринта
	 */
	async GetTaskOfSprintId(request: TaskSptintsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'GetTaskOfSprintId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить задачу
	 */
	async TaskGet(request: TaskGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'TaskGet',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить файл к задачи
	 */
	async AddFile(request: AttachFileTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'AddFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить файлы Задачи
	 */
	async GetFiles(request: GetFilesTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'GetFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async RemoveFiles(request: RemoveFilesTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskService',
			Method: 'RemoveFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Для большой формы
	 */
	async taskMainCreateAsync(query: TaskMainCreateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'TaskMainCreate',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Редактирования больших полей задачи
	 */
	async taskMainEditAsync(request: TaskMainEditRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'TaskMainEdit',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * История  статусов
	 */
	async getHistoryStatusAsync(page: PageRequest): Promise<GetHistoryStatusResponse> {
		return new Promise<GetHistoryStatusResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'GetHistoryStatus',
				Value: typeof(page) === 'object' ? JSON.stringify(page) : page,
				Callback: (response: WsResponseModelT<GetHistoryStatusResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetHistoryStatusResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список задач в кратком описании
	 */
	async getTasksShortAsync(tasks: Array<number>): Promise<Array<TaskShortInfo>> {
		return new Promise<Array<TaskShortInfo>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'GetTasksShort',
				Value: typeof(tasks) === 'object' ? JSON.stringify(tasks) : tasks,
				Callback: (response: WsResponseModelT<Array<TaskShortInfo>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<TaskShortInfo>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поиск
	 */
	async getEstimatePerformersAsync(request: EstimatePerformerGetRequest): Promise<Array<EstimatePerformerResponse>> {
		return new Promise<Array<EstimatePerformerResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'GetEstimatePerformers',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<EstimatePerformerResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<EstimatePerformerResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить задачу по ид спринта
	 */
	async getTaskOfSprintIdAsync(request: TaskSptintsRequest): Promise<TaskSprintsResponse> {
		return new Promise<TaskSprintsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'GetTaskOfSprintId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<TaskSprintsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskSprintsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить задачу
	 */
	async taskGetAsync(request: TaskGetRequest): Promise<TaskMainResponse> {
		return new Promise<TaskMainResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'TaskGet',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<TaskMainResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskMainResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить файл к задачи
	 */
	async addFileAsync(request: AttachFileTaskRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'AddFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить файлы Задачи
	 */
	async getFilesAsync(request: GetFilesTaskRequest): Promise<FilePageResponse> {
		return new Promise<FilePageResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'GetFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<FilePageResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as FilePageResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async removeFilesAsync(request: RemoveFilesTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskService',
				Method: 'RemoveFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}